import { graphql } from "@/graphql/generated";

export const batchUpdateMunicipalPropertyValueListMutationDocument = graphql(/* GraphQL */ `
    mutation BatchUpdateMunicipalPropertyValueList($input: BatchUpdateMunicipalPropertyValueInput!) {
      batchUpdateMunicipalPropertyValueList(input: $input) {
        id
        valueList { id sectorKey subsectorKey energySourceKey amount dataSource gpcQualityRating }
      }
    }
  `);
